import { LTLTradingPartnerCompatibilityProfile } from 'lib/api/getLTLCustomerStaff';

import { ThreeGCompatibilityProfileItem, ThreeGProfileType } from '../../types';

export function mapTradingPartnerCompatibilityProfilesToForm(
  profiles: LTLTradingPartnerCompatibilityProfile[] | undefined
): ThreeGCompatibilityProfileItem[] {
  if (!profiles?.length) {
    return [];
  }

  return profiles.map((p) => ({
    id: String(p.id),
    profileType: p.profileType as ThreeGProfileType,
    profileName: String(p.profileId),
    profileNameLabel: p.profileName,
    isReadOnly: true,
  }));
}
